<script>
  // "View Users" drawer for an uploaded ("From CSV") audience: the imported user ids, each
  // linking to that user's page. Built from the form's own ids — no lookup request, so it
  // also shows ids imported but not yet saved.
  import { Link } from '@inertiajs/svelte'
  import Drawer from './drawer.svelte'

  let { open = $bindable(false), userIds = [], title = 'Audience Users' } = $props()
</script>

<Drawer bind:open {title}>
  <p class="text-sm text-base-content/60 mb-3">{userIds.length} {userIds.length === 1 ? 'user' : 'users'} included.</p>
  <ul class="space-y-1">
    {#each userIds as id (id)}
      <li class="text-sm font-mono"><Link href={`/users/${id}`} class="link link-hover">{id}</Link></li>
    {/each}
  </ul>
</Drawer>
